import { render, staticRenderFns } from "./contact-privacy.vue?vue&type=template&id=7cd4cd94&scoped=true&lang=pug&"
var script = {}
import style0 from "./contact-privacy.vue?vue&type=style&index=0&id=7cd4cd94&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd4cd94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cd4cd94')) {
      api.createRecord('7cd4cd94', component.options)
    } else {
      api.reload('7cd4cd94', component.options)
    }
    module.hot.accept("./contact-privacy.vue?vue&type=template&id=7cd4cd94&scoped=true&lang=pug&", function () {
      api.rerender('7cd4cd94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/info/contact-privacy.vue"
export default component.exports